const fakeData = (length?: number) => {
  const arr = [
    {
      firstName: "skin-bn60p",
      lastName: "knowledge-5ugrt",
      age: 8,
      visits: 72,
      progress: 27,
      status: "complicated",
    },
    {
      firstName: "woman-bmbjr",
      lastName: "cigarette-49hob",
      age: 22,
      visits: 94,
      progress: 23,
      status: "relationship",
    },
    {
      firstName: "two-7lfbv",
      lastName: "president-99ohe",
      age: 28,
      visits: 90,
      progress: 14,
      status: "relationship",
    },
    {
      firstName: "economics-r4txa",
      lastName: "lace-ucbdm",
      age: 27,
      visits: 0,
      progress: 21,
      status: "relationship",
    },
    {
      firstName: "zebra-moek4",
      lastName: "history-kl93d",
      age: 11,
      visits: 26,
      progress: 52,
      status: "complicated",
    },
    {
      firstName: "priority-h4owd",
      lastName: "sea-5x4s8",
      age: 11,
      visits: 69,
      progress: 71,
      status: "complicated",
    },
    {
      firstName: "ad-155l2",
      lastName: "coffee-unhmp",
      age: 3,
      visits: 1,
      progress: 39,
      status: "complicated",
    },
    {
      firstName: "professor-i494l",
      lastName: "brain-iv7s4",
      age: 7,
      visits: 99,
      progress: 22,
      status: "relationship",
    },
    {
      firstName: "deer-oyvb7",
      lastName: "city-3fxnw",
      age: 21,
      visits: 49,
      progress: 98,
      status: "single",
    },
    {
      firstName: "cap-beb5b",
      lastName: "improvement-0u6da",
      age: 17,
      visits: 84,
      progress: 39,
      status: "single",
    },
    {
      firstName: "boat-30lbd",
      lastName: "potato-k8bhb",
      age: 26,
      visits: 38,
      progress: 4,
      status: "complicated",
    },
    {
      firstName: "fan-tpm3y",
      lastName: "anxiety-2xbra",
      age: 26,
      visits: 63,
      progress: 81,
      status: "complicated",
    },
    {
      firstName: "environment-l2zxv",
      lastName: "current-u08xg",
      age: 3,
      visits: 70,
      progress: 23,
      status: "relationship",
    },
    {
      firstName: "range-n3iop",
      lastName: "war-owo1y",
      age: 29,
      visits: 46,
      progress: 93,
      status: "complicated",
    },
    {
      firstName: "art-ek4zr",
      lastName: "nation-i5n3p",
      age: 28,
      visits: 57,
      progress: 75,
      status: "single",
    },
    {
      firstName: "writer-46ks2",
      lastName: "interaction-698hh",
      age: 12,
      visits: 25,
      progress: 42,
      status: "complicated",
    },
    {
      firstName: "amusement-bf9y1",
      lastName: "cook-w5z15",
      age: 1,
      visits: 59,
      progress: 89,
      status: "complicated",
    },
    {
      firstName: "information-lnb44",
      lastName: "virus-ta749",
      age: 15,
      visits: 51,
      progress: 92,
      status: "single",
    },
    {
      firstName: "mice-2z1rs",
      lastName: "field-p97c0",
      age: 5,
      visits: 43,
      progress: 52,
      status: "single",
    },
    {
      firstName: "birth-amyxx",
      lastName: "notebook-xoa3u",
      age: 20,
      visits: 32,
      progress: 92,
      status: "relationship",
    },
    {
      firstName: "storage-b0kyf",
      lastName: "whip-4gvdr",
      age: 29,
      visits: 58,
      progress: 92,
      status: "single",
    },
    {
      firstName: "floor-nq4c8",
      lastName: "stick-d3494",
      age: 13,
      visits: 72,
      progress: 58,
      status: "single",
    },
    {
      firstName: "tennis-0s1cv",
      lastName: "club-i5t99",
      age: 20,
      visits: 7,
      progress: 27,
      status: "complicated",
    },
    {
      firstName: "surprise-0c0j0",
      lastName: "yard-moqtj",
      age: 6,
      visits: 68,
      progress: 35,
      status: "relationship",
    },
    {
      firstName: "reading-ius00",
      lastName: "cat-p2vz7",
      age: 1,
      visits: 44,
      progress: 46,
      status: "relationship",
    },
    {
      firstName: "holiday-a9ejw",
      lastName: "requirement-fmih2",
      age: 19,
      visits: 41,
      progress: 3,
      status: "relationship",
    },
    {
      firstName: "cactus-51tc7",
      lastName: "playground-snx2y",
      age: 19,
      visits: 61,
      progress: 47,
      status: "single",
    },
    {
      firstName: "branch-z77mv",
      lastName: "toad-e8bx6",
      age: 29,
      visits: 50,
      progress: 2,
      status: "complicated",
    },
    {
      firstName: "agency-5fhch",
      lastName: "crayon-b8k1n",
      age: 19,
      visits: 11,
      progress: 3,
      status: "complicated",
    },
    {
      firstName: "wing-nwv6a",
      lastName: "kettle-u3t6s",
      age: 17,
      visits: 53,
      progress: 12,
      status: "relationship",
    },
    {
      firstName: "committee-fjvkw",
      lastName: "afterthought-cel3u",
      age: 10,
      visits: 21,
      progress: 63,
      status: "relationship",
    },
    {
      firstName: "men-reh3u",
      lastName: "morning-2cjib",
      age: 23,
      visits: 24,
      progress: 92,
      status: "single",
    },
    {
      firstName: "highway-zq7le",
      lastName: "vein-d788n",
      age: 18,
      visits: 45,
      progress: 4,
      status: "single",
    },
    {
      firstName: "lock-psjy0",
      lastName: "patch-fmwcl",
      age: 29,
      visits: 47,
      progress: 40,
      status: "single",
    },
    {
      firstName: "baseball-m63g2",
      lastName: "whip-24fm1",
      age: 19,
      visits: 9,
      progress: 65,
      status: "complicated",
    },
    {
      firstName: "quill-v3usk",
      lastName: "basketball-45o6z",
      age: 26,
      visits: 49,
      progress: 63,
      status: "single",
    },
    {
      firstName: "stew-oz5o4",
      lastName: "magic-r31sr",
      age: 8,
      visits: 82,
      progress: 48,
      status: "single",
    },
    {
      firstName: "card-kan5f",
      lastName: "accident-d2s3c",
      age: 12,
      visits: 51,
      progress: 11,
      status: "single",
    },
    {
      firstName: "adjustment-3bn71",
      lastName: "cart-b870w",
      age: 4,
      visits: 57,
      progress: 62,
      status: "relationship",
    },
    {
      firstName: "efficiency-q0kro",
      lastName: "database-2dzi6",
      age: 7,
      visits: 76,
      progress: 95,
      status: "complicated",
    },
    {
      firstName: "milk-kf918",
      lastName: "pest-klzm0",
      age: 6,
      visits: 0,
      progress: 38,
      status: "single",
    },
    {
      firstName: "patience-agcac",
      lastName: "drum-abexf",
      age: 9,
      visits: 54,
      progress: 8,
      status: "complicated",
    },
    {
      firstName: "attention-q1qv4",
      lastName: "president-bahca",
      age: 19,
      visits: 10,
      progress: 85,
      status: "single",
    },
    {
      firstName: "line-gqhmt",
      lastName: "expression-th6ns",
      age: 15,
      visits: 3,
      progress: 61,
      status: "relationship",
    },
    {
      firstName: "engine-jlb1w",
      lastName: "team-migjb",
      age: 25,
      visits: 63,
      progress: 3,
      status: "complicated",
    },
    {
      firstName: "driving-dsn7x",
      lastName: "apparatus-9cvq6",
      age: 28,
      visits: 82,
      progress: 70,
      status: "single",
    },
    {
      firstName: "clocks-5s7i8",
      lastName: "message-w9qrx",
      age: 23,
      visits: 57,
      progress: 72,
      status: "relationship",
    },
    {
      firstName: "breath-bfani",
      lastName: "beam-3bm9p",
      age: 26,
      visits: 1,
      progress: 71,
      status: "relationship",
    },
    {
      firstName: "beginner-drw59",
      lastName: "cushion-mfjad",
      age: 17,
      visits: 68,
      progress: 99,
      status: "single",
    },
    {
      firstName: "planes-c6lrk",
      lastName: "vest-qcaec",
      age: 12,
      visits: 38,
      progress: 58,
      status: "complicated",
    },
    {
      firstName: "revenue-sfg6m",
      lastName: "crack-azr27",
      age: 15,
      visits: 13,
      progress: 21,
      status: "single",
    },
    {
      firstName: "deer-zm5vb",
      lastName: "snakes-d1p8p",
      age: 23,
      visits: 63,
      progress: 76,
      status: "single",
    },
    {
      firstName: "trouble-wcq1c",
      lastName: "restaurant-vxwim",
      age: 25,
      visits: 29,
      progress: 58,
      status: "single",
    },
    {
      firstName: "ghost-fzygl",
      lastName: "agency-l7dkc",
      age: 24,
      visits: 44,
      progress: 65,
      status: "relationship",
    },
    {
      firstName: "banana-3sl9z",
      lastName: "stream-kuz0l",
      age: 19,
      visits: 65,
      progress: 91,
      status: "relationship",
    },
    {
      firstName: "zephyr-0rgwk",
      lastName: "energy-jf1xf",
      age: 14,
      visits: 93,
      progress: 10,
      status: "relationship",
    },
    {
      firstName: "letters-zdkun",
      lastName: "recommendation-qczd0",
      age: 10,
      visits: 63,
      progress: 2,
      status: "relationship",
    },
    {
      firstName: "estate-fuzxx",
      lastName: "haircut-k1asn",
      age: 27,
      visits: 20,
      progress: 79,
      status: "complicated",
    },
    {
      firstName: "agency-29xmt",
      lastName: "fiction-1kcag",
      age: 17,
      visits: 58,
      progress: 92,
      status: "complicated",
    },
    {
      firstName: "cows-y2v6w",
      lastName: "silk-lwz9o",
      age: 1,
      visits: 58,
      progress: 68,
      status: "relationship",
    },
    {
      firstName: "article-8kpe0",
      lastName: "robin-1xm4t",
      age: 7,
      visits: 66,
      progress: 55,
      status: "complicated",
    },
    {
      firstName: "depression-csb2c",
      lastName: "wool-do0pl",
      age: 0,
      visits: 23,
      progress: 7,
      status: "single",
    },
    {
      firstName: "sneeze-a0ccu",
      lastName: "jeans-s920u",
      age: 2,
      visits: 80,
      progress: 45,
      status: "relationship",
    },
    {
      firstName: "development-x06eh",
      lastName: "cable-r9pvp",
      age: 22,
      visits: 97,
      progress: 7,
      status: "single",
    },
    {
      firstName: "polish-htqh8",
      lastName: "instance-3xysv",
      age: 1,
      visits: 54,
      progress: 14,
      status: "relationship",
    },
    {
      firstName: "hotel-xubqh",
      lastName: "street-13q4l",
      age: 10,
      visits: 12,
      progress: 0,
      status: "relationship",
    },
    {
      firstName: "discovery-6kxb8",
      lastName: "touch-qod70",
      age: 19,
      visits: 68,
      progress: 94,
      status: "complicated",
    },
    {
      firstName: "pencil-s20jc",
      lastName: "thread-0r3b5",
      age: 11,
      visits: 57,
      progress: 39,
      status: "single",
    },
    {
      firstName: "punishment-r9e7m",
      lastName: "curve-ysk65",
      age: 15,
      visits: 80,
      progress: 83,
      status: "single",
    },
    {
      firstName: "people-sw8xp",
      lastName: "injury-ximbb",
      age: 18,
      visits: 22,
      progress: 56,
      status: "single",
    },
    {
      firstName: "suggestion-s1a61",
      lastName: "earthquake-m2qzq",
      age: 25,
      visits: 64,
      progress: 10,
      status: "relationship",
    },
    {
      firstName: "trail-rsdsv",
      lastName: "neck-6wl7v",
      age: 8,
      visits: 76,
      progress: 11,
      status: "single",
    },
    {
      firstName: "toy-fugxs",
      lastName: "stitch-43s1r",
      age: 2,
      visits: 64,
      progress: 45,
      status: "complicated",
    },
    {
      firstName: "feather-mkds9",
      lastName: "arch-dewo3",
      age: 24,
      visits: 85,
      progress: 6,
      status: "relationship",
    },
    {
      firstName: "hearing-g3l3l",
      lastName: "harmony-lt1wm",
      age: 10,
      visits: 33,
      progress: 10,
      status: "single",
    },
    {
      firstName: "editor-59prq",
      lastName: "organization-yye6t",
      age: 25,
      visits: 6,
      progress: 36,
      status: "complicated",
    },
    {
      firstName: "thanks-hbn8w",
      lastName: "sink-joj1y",
      age: 24,
      visits: 56,
      progress: 68,
      status: "relationship",
    },
    {
      firstName: "support-z7fep",
      lastName: "owner-qc826",
      age: 27,
      visits: 53,
      progress: 78,
      status: "single",
    },
    {
      firstName: "fan-ejxjq",
      lastName: "argument-95uzu",
      age: 26,
      visits: 55,
      progress: 14,
      status: "single",
    },
    {
      firstName: "salt-ewr88",
      lastName: "car-jin2p",
      age: 8,
      visits: 71,
      progress: 53,
      status: "single",
    },
    {
      firstName: "fear-2tdya",
      lastName: "television-dt910",
      age: 10,
      visits: 42,
      progress: 14,
      status: "relationship",
    },
    {
      firstName: "feast-mzj5o",
      lastName: "agency-xbkmx",
      age: 19,
      visits: 10,
      progress: 41,
      status: "single",
    },
    {
      firstName: "existence-jvbka",
      lastName: "economics-o0wjq",
      age: 2,
      visits: 47,
      progress: 49,
      status: "relationship",
    },
    {
      firstName: "height-ah0lo",
      lastName: "root-fbg1w",
      age: 18,
      visits: 47,
      progress: 90,
      status: "single",
    },
    {
      firstName: "apple-tnop4",
      lastName: "disgust-yvt6k",
      age: 12,
      visits: 73,
      progress: 90,
      status: "complicated",
    },
    {
      firstName: "guide-ejue4",
      lastName: "sort-cp1ys",
      age: 28,
      visits: 76,
      progress: 1,
      status: "single",
    },
    {
      firstName: "message-8aef3",
      lastName: "throne-abm5u",
      age: 26,
      visits: 64,
      progress: 8,
      status: "single",
    },
    {
      firstName: "outcome-w14qn",
      lastName: "boyfriend-darn6",
      age: 5,
      visits: 21,
      progress: 51,
      status: "single",
    },
    {
      firstName: "cobweb-4vqrg",
      lastName: "harmony-inkew",
      age: 0,
      visits: 27,
      progress: 40,
      status: "single",
    },
    {
      firstName: "feather-4in9r",
      lastName: "rifle-5qzcu",
      age: 16,
      visits: 87,
      progress: 62,
      status: "single",
    },
    {
      firstName: "mountain-e0mqx",
      lastName: "jelly-bsm5k",
      age: 27,
      visits: 21,
      progress: 25,
      status: "single",
    },
    {
      firstName: "debt-4b0jq",
      lastName: "philosophy-1ow9n",
      age: 14,
      visits: 96,
      progress: 89,
      status: "relationship",
    },
    {
      firstName: "dress-z3nhb",
      lastName: "believe-eeafb",
      age: 16,
      visits: 24,
      progress: 99,
      status: "complicated",
    },
    {
      firstName: "disgust-o7o86",
      lastName: "home-gd0wr",
      age: 19,
      visits: 59,
      progress: 45,
      status: "relationship",
    },
    {
      firstName: "ant-kacdm",
      lastName: "writer-vz0t8",
      age: 13,
      visits: 83,
      progress: 46,
      status: "single",
    },
    {
      firstName: "linen-tqvv4",
      lastName: "unit-ynbsz",
      age: 26,
      visits: 44,
      progress: 47,
      status: "single",
    },
    {
      firstName: "charity-kz138",
      lastName: "stream-3ezp1",
      age: 26,
      visits: 99,
      progress: 81,
      status: "single",
    },
    {
      firstName: "operation-plkno",
      lastName: "road-hznn1",
      age: 10,
      visits: 98,
      progress: 13,
      status: "single",
    },
    {
      firstName: "base-kd75v",
      lastName: "fairies-jdnzl",
      age: 20,
      visits: 83,
      progress: 61,
      status: "relationship",
    },
    {
      firstName: "cactus-v7asu",
      lastName: "initiative-nqw0h",
      age: 12,
      visits: 71,
      progress: 89,
      status: "complicated",
    },
  ];

  if (length) {
    return arr.slice(0, length);
  }

  return arr;
};

export default fakeData;
